import { linkToFirstSignIn } from "$routes/user/links";
import { useLocation } from "react-router-dom";
import { ExistingUserWhatsappConsentOverlay } from "./existing-user-whatsapp-consent-overlay/existing-user-whatsapp-consent-overlay";

const HIDDEN_PATHS = [linkToFirstSignIn()];

/**
 * The purpose of this component is to manage overlays components that are
 * not coupled to a specific page.
 */
export const Overlays: FC = () => {
  const { pathname } = useLocation();

  const shouldHide = HIDDEN_PATHS.some((path) => pathname.includes(path));

  if (shouldHide) {
    return null;
  }

  return (
    <div data-testid="overlays">
      <ExistingUserWhatsappConsentOverlay />
    </div>
  );
};
